import { render } from "./ConfigureCNames.vue?vue&type=template&id=168f614a"
import script from "./ConfigureCNames.vue?vue&type=script&lang=js"
export * from "./ConfigureCNames.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__